import { Injectable } from '@angular/core';

import { NgxUiLoaderService, NgxUiLoaderConfig, SPINNER } from 'ngx-ui-loader';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  showLoader = true;
  public static ngxUiLoaderConfig: NgxUiLoaderConfig = {
    //fgsSize: 0,
    fgsColor: '#ebebeb',

    pbColor: '#ebebeb',
    pbThickness: 4,

    //text: 'Loading...',
    //textColor: '#FFFFFF',
    //overlayColor: '#222d43',

    //logoUrl: 'assets/images/loader.gif',
    //logoSize: 120,
  };

  constructor(readonly ngxUiLoaderService: NgxUiLoaderService) {}

  start() {
    if (this.showLoader) {
      this.ngxUiLoaderService.start();
    }
  }

  stop() {
    this.ngxUiLoaderService.stop();
  }
}
